import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { Case } from '../models/cases/case';
import { CaseClientContact } from '../models/cases/caseClientContact';
import { ContactSearchParams } from '../models/clients/contactSearchParams';
import { NgSelectProps } from '../models/ng-select-props';
import { SearchParams } from '../models/searchParams';

@Component({
  selector: 'app-case-contact',
  templateUrl: './case-contact.component.html',
  styleUrls: ['./case-contact.component.scss']
})
export class CaseContactComponent implements OnInit {
  @Input() fileInfo: Case;
  @Input() isEditable;
  contact: CaseClientContact;
  modalRef: NgbModalRef;
  contactNgSelect: NgSelectProps;
  editContact: CaseClientContact;
  contactParams: SearchParams = new ContactSearchParams();

  contacts: CaseClientContact[] = [];


  @Output() submitContact: EventEmitter<Case> = new EventEmitter();

  @ViewChild('contactModal') contactModal;
  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;

  constructor(
    private modalService: NgbModal,
    private filesApi: FilesApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private clientsApi: ClientsApiService,
  ) { }

  ngOnInit(): void {
    this.contactNgSelect = new NgSelectProps(this.clientsApi.getClientContacts, this.contactParams, [this.fileInfo.clients[0].client.id]);
    this.fileInfo.clients.forEach(c => {
      this.contacts.concat(c.contacts);
    })

  }


  openContactsSelect() {
    if (!this.contactNgSelect.items.length) {
      this.contactNgSelect.loadItems(true);
      this.fileInfo.clients.forEach(c => {
        const clients = [];
        this.clientsApi.getClientContacts(this.contactParams, c.client.id).subscribe(r => {
          clients.concat(r.results);
        })

        this.contactNgSelect.items = clients;
      });
    }
  }




  openContactModal(contact: CaseClientContact) {
    this.editContact = contact ? Object.assign(new CaseClientContact(), contact) : new CaseClientContact;
    this.modalRef = this.modalService.open(this.contactModal, {
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }



  onSubmit() {
    this.editContact.contactId = this.editContact.contact.id;
    this.spinner.show();
    if (!this.editContact.id) {
      this.editContact.caseId = this.fileInfo.id;
      this.filesApi.createCaseClientContact(this.editContact).subscribe(
        c => {
          // this.fileInfo.contacts.unshift(c);
          this.modalRef.close();
          this.spinner.hide();
          this.toastr.success('Contact Added', 'Success');
          this.submitContact.emit(this.fileInfo);
        }
      )
    } else {
      this.filesApi.updateCaseClientContact(this.editContact).subscribe(
        c => {
          // this.fileInfo.contacts.forEach((v, i, arr) => {
          //   if (v.id === c.id) {
          //     arr[i] = c;
          //   }
          // })
          this.modalRef.close();
          this.spinner.hide();
          this.toastr.success('Contact Updated', 'Success');
          this.submitContact.emit(this.fileInfo);
        }
      )
    }
  }

  deleteContact(contact: CaseClientContact) {
    // this.confirmModal.open(`Are you sure you want to delete '${contact.name}'`, () => {
    //   contact.caseId = this.fileInfo.id;
    //   this.spinner.show();
    //   this.filesApi.deleteCaseClientContact(contact).subscribe(
    //     c => {
    //       this.fileInfo.contacts.splice(this.fileInfo.contacts.findIndex((val) => val.id === contact.id), 1);
    //       this.spinner.hide();
    //       this.confirmModal.close();
    //       this.toastr.success('Contact Deleted', 'Success');
    //       this.submitContact.emit(this.fileInfo);
    //     }
    //   )
    // });
  }

  searchFn() {
    return true;
  }

}
